<div class="main-content portfolio-page">
  <div class="container-fluid p-0">
    <div class="d-flex justify-content-end">
      <div class="seguimiento-tabs">
        <button
          type="button"
          class="seguimiento-tab"
          [class.seguimiento-tab--active]="activeTab === 'proyectos'"
          (click)="setTab('proyectos')"
        >
          <mat-icon class="seguimiento-tab__icon">folder</mat-icon>
          <span>Proyectos</span>
        </button>
        <button
          type="button"
          class="seguimiento-tab"
          [class.seguimiento-tab--active]="activeTab === 'servicios'"
          (click)="setTab('servicios')"
        >
          <mat-icon class="seguimiento-tab__icon">schedule</mat-icon>
          <span>Servicios</span>
        </button>
      </div>
    </div>

    <app-consulta-servicios *ngIf="activeTab === 'servicios'"></app-consulta-servicios>

    <ng-container *ngIf="activeTab === 'proyectos'">
    <section class="card portfolio-surface mx-1 mt-1 mb-2">
      <div class="card-body card-body  pr-2 pl-1">
        <div class="portfolio-header d-flex align-items-center justify-content-between flex-nowrap gap-2">
          <div class="d-flex align-items-center gap-2 flex-shrink-0">
            <h1 class="portfolio-title mb-0 pl-2">Seguimiento de proyectos</h1>
            <span
              *ngFor="let metric of overviewMetrics"
              class="metric-pill metric-pill--header px-2 py-0"
              [class.metric-pill--accent]="metric.accent"
            >
              <strong *ngIf="metric.value">{{ metric.value }}</strong>
              {{ metric.label }}
            </span>
          </div>

          <div class="filter-group d-flex align-items-center flex-nowrap gap-2">
            <label class="filter-chip" (click)="abrirFiltro(clienteSelect, $event)" (keydown.enter)="abrirFiltro(clienteSelect, $event)">
              <mat-icon class="filter-chip__icon">apartment</mat-icon>
              <span class="filter-chip__label">Cliente:</span>
              <select #clienteSelect class="filter-chip__select text-truncate" [(ngModel)]="selectedClientId" (change)="onClientChange()">
                <option *ngFor="let client of clientOptions; trackBy: trackByOptionId" [ngValue]="client.id">
                  {{ client.text }}
                </option>
              </select>
              <mat-icon class="filter-chip__chevron">expand_more</mat-icon>
            </label>

            <label class="filter-chip" (click)="abrirFiltro(liderSelect, $event)" (keydown.enter)="abrirFiltro(liderSelect, $event)">
              <mat-icon class="filter-chip__icon">person</mat-icon>
              <span class="filter-chip__label">Líder:</span>
              <select #liderSelect class="filter-chip__select text-truncate" [(ngModel)]="selectedLeaderId" (change)="onLeaderChange()">
                <option *ngFor="let leader of leaderOptions; trackBy: trackByOptionId" [ngValue]="leader.id">
                  {{ leader.text }}
                </option>
              </select>
              <mat-icon class="filter-chip__chevron">expand_more</mat-icon>
            </label>

            <label class="filter-chip" (click)="abrirFiltro(estatusSelect, $event)" (keydown.enter)="abrirFiltro(estatusSelect, $event)">
              <mat-icon class="filter-chip__icon">flag</mat-icon>
              <span class="filter-chip__label">Estatus:</span>
              <select #estatusSelect class="filter-chip__select text-truncate" [(ngModel)]="selectedStatus" (change)="onStatusChange()">
                <option *ngFor="let status of statusOptions" [ngValue]="status">
                  {{ status }}
                </option>
              </select>
              <mat-icon class="filter-chip__chevron">expand_more</mat-icon>
            </label>

            <label class="filter-chip" (click)="fechaCortePicker.open()" (keydown.enter)="fechaCortePicker.open()">
              <mat-icon class="filter-chip__icon">event</mat-icon>
              <span class="filter-chip__label">Corte:</span>
              <input
                matInput
                readonly
                [matDatepicker]="fechaCortePicker"
                [(ngModel)]="selectedDateValue"
                (dateChange)="onDateChange($event.value)"
                class="filter-chip__select filter-chip__date-input"
                placeholder="Todas"
              />
              <mat-datepicker #fechaCortePicker></mat-datepicker>
              <mat-icon class="filter-chip__chevron">expand_more</mat-icon>
            </label>

            <button
              type="button"
              class="btn btn-sm btn-outline-secondary reporte-btn d-inline-flex align-items-center gap-1"
              (click)="exportarPdf()"
            >
              <mat-icon class="reporte-btn__icon">picture_as_pdf</mat-icon> REPORTE
            </button>
          </div>
        </div>
      </div>
    </section>
    <div class="row" *ngIf="!isLoading && filteredPortfolioCards.length > 0">
      <div
        *ngFor="let project of paginatedPortfolioCards; trackBy: trackByCardId"
        class="col-12 col-md-6 col-xl-4 mt-1 mb-2"
      >
        <article
          class="card project-card h-100 mt-1 mb-1"
          [ngClass]="'project-card--risk-' + project.statusRisk"
        >
          <div class="card-body px-3 pt-3 pb-1 d-flex flex-column">
            <div class="project-card__content">
              <div class="project-card__header">
                <div class="project-card__headline">
                  <div class="project-card__meta-row">
                    <div class="risk-badge" [ngClass]="'risk-badge--' + project.statusRisk">
                      <span class="risk-badge__dot"></span>
                      <span>{{ getRiskLabel(project.statusRisk) }}</span>
                    </div>
                    <div class="project-card__chips">
                      <button
                        type="button"
                        class="project-card__risk-count"
                        *ngIf="project.riskCount > 0"
                        (click)="openProjectRisks(project)"
                        [attr.aria-label]="'Abrir riesgos del proyecto ' + project.title"
                      >
                        <mat-icon class="project-card__risk-count-icon">warning_amber</mat-icon>
                        {{ project.riskCount }}
                        {{ project.riskCount > 1 ? "RIESGOS" : "RIESGO" }}
                      </button>
                      <span
                        class="status-badge text-uppercase text-center px-2"
                        [ngClass]="'status-badge--' + project.statusTone"
                      >
                        {{
                          !project.status ||
                          project.status.trim().toLowerCase() === "sin estatus"
                            ? "ACTIVO"
                            : project.status
                        }}
                      </span>
                    </div>
                  </div>
                  <h2 class="project-card__title text-left mb-0">{{ project.title }}</h2>
                  <p class="project-card__department mb-0">
                    {{ project.client }}
                  </p>
                </div>
              </div>

              <!-- Avance General -->
              <div class="mb-1">
                <span class="project-card__progress-title">Avance General</span>

                <div class="d-flex align-items-baseline justify-content-between mb-1">
                  <span class="project-card__progress-label">Real</span>
                  <span class="avance-pct" [ngClass]="'risk-badge--' + project.statusRisk">{{ project.progress }}%</span>
                </div>
                <div class="progress progress-track mb-1">
                  <div class="progress-bar progress-track__value"
                       [ngClass]="getRealProgressBarClass(project)"
                       [style.width.%]="project.progress"></div>
                </div>

                <div class="d-flex align-items-baseline justify-content-between mb-1">
                  <span class="project-card__progress-label">Planeado</span>
                  <span class="avance-pct avance-pct--planned">{{ project.plannedProgress }}%</span>
                </div>
                <div class="progress progress-track progress-track--planned mb-2">
                  <div class="progress-bar progress-track__value"
                       [ngClass]="getPlannedProgressBarClass(project)"
                       [style.width.%]="project.plannedProgress"></div>
                </div>
              </div>

              <!-- Badge de fase -->
              <span class="badge d-inline-flex align-items-center phase-badge" [ngClass]="getFaseBadgeClass(project.fase)">
                <mat-icon class="phase-badge__icon">{{ getFaseIcon(project.fase) }}</mat-icon>
                Fase: {{ getFaseLabel(project.fase) }}
              </span>

              <!-- Progreso específico de Desarrollo -->
              <div class="rounded-2 px-2 dev-progress-block"
                   *ngIf="project.fase === 'DESARROLLO' && project.avanceDesarrollo != null">
                <span class="project-card__progress-title dev-progress-block__title">Progreso Desarrollo</span>
                <div class="d-flex align-items-baseline justify-content-between mb-1">
                  <span class="project-card__progress-label">Real</span>
                  <span class="avance-pct avance-pct--dev">{{ project.avanceDesarrollo | number:'1.0-1' }}%</span>
                </div>
                <div class="progress progress-track">
                  <div class="progress-bar progress-track__value progress-track__value--dev"
                       [style.width.%]="project.avanceDesarrollo"></div>
                </div>
              </div>

              <!-- Stepper sub-fases QA / Producción -->
              <div class="d-flex align-items-start" *ngIf="project.fase !== 'DESARROLLO'"
                   [ngClass]="'stepper--' + project.fase.toLowerCase()">
                <ng-container *ngFor="let sf of getActiveSubFases(project); let i = index; let last = last">
                  <div class="d-flex flex-column align-items-center gap-1 stepper-node">
                    <div class="stepper-circle" [ngClass]="'stepper-circle--' + sf.estado">
                      <mat-icon class="stepper-icon" *ngIf="sf.estado === 'completado'">check</mat-icon>
                      <mat-icon class="stepper-icon" *ngIf="sf.estado === 'con-observaciones'">priority_high</mat-icon>
                    </div>
                    <span class="stepper-label">{{ sf.nombre | uppercase }}</span>
                    <span class="stepper-nota" *ngIf="sf.nota">{{ sf.nota }}</span>
                  </div>
                  <div class="stepper-connector" *ngIf="!last"
                       [class.stepper-connector--dashed]="isNextSubFaseOpcional(project, i)"
                       [class.stepper-connector--done]="sf.estado === 'completado'">
                  </div>
                </ng-container>
              </div>

              <!-- Nota del seguimiento -->
              <section class="project-note p-2" [ngClass]="'project-note--' + project.statusTone">
                <div class="project-note__header mb-1">
                  <span class="project-note__label">{{ getNoteLabel(project.fase) }}</span>
                  <span class="project-note__date" *ngIf="project.noteDate">
                    {{ project.noteDate }}
                  </span>
                </div>
                <p class="project-note__text mb-0">{{ project.note }}</p>
              </section>
            </div>

            <div class="d-flex align-items-center justify-content-between project-card__footer mt-auto pt-2 pb-2 mb-0">
              <div class="d-flex align-items-center owner">
                <img src="assets/img/faces/profile.png" [alt]="project.owner" />
                <div class="ml-2">
                  <span class="d-block owner__role">Líder del proyecto</span>
                  <strong class="d-block">{{ project.owner }}</strong>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-sm btn-outline-primary py-0 px-2 d-inline-flex align-items-center more-btn"
                [routerLink]="['/consultaSeguimientos/detalle', project.id]"
                [queryParams]="getDetailQueryParams()"
                aria-label="Ver detalle"
              >
                <mat-icon class="more-btn__icon">arrow_outward</mat-icon>
                <span>Detalle</span>
              </button>
            </div>
          </div>
        </article>
      </div>
    </div>

    <div class="row justify-content-end" *ngIf="!isLoading && filteredPortfolioCards.length > 0">
      <div class="col-4  ml-auto" id="pagination-card m-0">
        <div class="portfolio-pagination mt-1 mb-2 py-1">
          <button
            type="button"
            class="pagination-nav px-2 py-0"
            (click)="goToPreviousPage()"
            [disabled]="currentPage === 1"
          >
            <span class="pagination-nav__icon">&#8249;</span>
            <span>Anterior</span>
          </button>

          <div class="pagination-divider"></div>

          <button
            type="button"
            class="pagination-page"
            *ngFor="let item of paginationItems; trackBy: trackByPaginationItem"
            [class.pagination-page--active]="item === currentPage"
            [class.pagination-page--dots]="item === '...'"
            [disabled]="item === '...'"
            (click)="onPaginationItemClick(item)"
          >
            {{ item }}
          </button>

          <div class="pagination-divider"></div>

          <button
            type="button"
            class="pagination-nav px-2 py-0"
            (click)="goToNextPage()"
            [disabled]="currentPage === totalPages"
          >
            <span>Siguiente</span>
            <span class="pagination-nav__icon">&#8250;</span>
          </button>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="isLoading">
      <div class="col-12">
        <article class="card project-card">
          <div class="card-body p-3 text-center">
            Cargando proyectos...
          </div>
        </article>
      </div>
    </div>

    <div class="row" *ngIf="!isLoading && filteredPortfolioCards.length === 0">
      <div class="col-12">
        <article class="card project-card">
          <div class="card-body p-3 text-center">
            No se encontraron proyectos para el estatus seleccionado.
          </div>
        </article>
      </div>
    </div>
    </ng-container>
  </div>
</div>


